import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { getDistance } from '@utilities/get-distance';

const useDistance = ({ longitude = null, latitude = null }) => {
  const [distance, setDistance] = useState(null);
  const [coordinates, setCoordinates] = useState(null);
  const distanceUnit = useSelector((state) => state.settings.settings?.['distanceUnit']);
  const unit = proximityIndicatorMap[distanceUnit] || '';

  useEffect(() => {
    let isMounted = true;

    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        ({ coords }) => {
          if (isMounted) {
            setCoordinates({ latitude: coords.latitude, longitude: coords.longitude });
            if (unit && longitude !== null && latitude !== null)
              setDistance(getDistance({ unit, from: coords, to: { longitude, latitude } }));
          }
        },
        (error) => {
          // Handle error silently to prevent memory leaks from error callbacks
          if (isMounted) {
            console.warn('Geolocation error:', error);
          }
        }
      );
    }

    return () => {
      isMounted = false;
    };
  }, [unit, longitude, latitude]);

  return { unit, distance, coordinates };
};

useDistance.propTypes = {
  latitude: PropTypes.any,
  longitude: PropTypes.any
};
const proximityIndicatorMap = { miles: 'mi', kilometers: 'km' };

export default useDistance;
